module.exports = __webpack_public_path__ + "static/media/AdmisionesCriticas.5e86cfff.svg";